import React, { useEffect, useRef } from 'react'
import { CondensedRecommendedFlightBanner } from '@pcln/horizon-package-components'
import { handleClick, handleComponentLoaded } from './helpers'
import { Box } from 'pcln-design-system'

export const RecommendedFlightBannerWrapper = (props) => {
  const { recommendedFlightBannerListing, recommendedFlightBannerListingProps = {}, bannerIndex } = props

  const { condensedBannerProps, ga4Data, openXsell } = recommendedFlightBannerListingProps
  const hasLoggedRef = useRef(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const resolvedGa4Data = {
    ...ga4Data,
    bannerIndex: bannerIndex ?? ga4Data?.bannerIndex ?? null,
  }

  const onClick = () => {
    handleClick(resolvedGa4Data)
    openXsell?.()
  }

  useEffect(() => {
    if (recommendedFlightBannerListing && condensedBannerProps && !hasLoggedRef.current) {
      handleComponentLoaded(resolvedGa4Data)
      hasLoggedRef.current = true
    }
  }, [recommendedFlightBannerListing, condensedBannerProps, resolvedGa4Data])

  if (!recommendedFlightBannerListing || !condensedBannerProps) return null

  const key = `pkg-banner-${recommendedFlightBannerListing.priceKey}`

  return (
    <Box px={[2, 2, 2, 2, 0]}>
      <CondensedRecommendedFlightBanner {...condensedBannerProps} onClick={onClick} key={key} />
    </Box>
  )
}
